export interface Gig {
  id: string;
  title: string;
  freelancer: string;
  ownerId: string;
  category: string;
  subcategory?: string;
  price: number | null;
  deliveryDays: number | null;
  rating: number | null;
  reviewsCount: number;
  location: string;
  description: string;
  deliverables: string;
  postedAt: string;
  cover: string;
}

export const gigCategories = [
  'Développement',
  'Design',
  'Marketing',
  'Rédaction',
  'Vidéo & Animation',
  'Business',
  'Data & IA',
  'Musique & Audio',
  'Commerçant',
  'BTP & Services',
  'Informatique',
  'Juridique',
  'Mode & Artisanat',
  'Montage vidéo',
];

export const gigSubcategories: Record<string, string[]> = {
  'BTP & Services': ['Maçonnerie', 'Électricité', 'Forgeron', 'Soudure', 'Peinture'],
  Informatique: ['Développeur', 'Codeur', 'Infographe', 'Traducteur', 'Transcription', 'Studio'],
  Juridique: ['Avocat', 'Avocate'],
  'Mode & Artisanat': ['Styliste', 'Tailleur', 'Coiffeur', 'Cordonnier'],
};

export const mockGigs: Gig[] = [
  {
    id: 'gig-1',
    title: 'Je crée votre site vitrine professionnel en 7 jours',
    freelancer: 'Matthew DOTSE',
    ownerId: 'freelancer-matthew-dotse',
    category: 'Développement',
    price: 150000,
    deliveryDays: 7,
    rating: 4.9,
    reviewsCount: 124,
    location: 'Lomé',
    description:
      "Je conçois un site vitrine moderne, rapide et responsive pour votre entreprise. Idéal pour présenter vos services, attirer des clients et renforcer votre image de marque. Livraison rapide et accompagnement inclus.",
    deliverables:
      "Site vitrine complet (jusqu'à 5 pages)\nDesign responsive mobile & ordinateur\nOptimisation de base pour le référencement\nFormulaire de contact\n1 mois de support après livraison",
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20professional%20website%20design%20displayed%20on%20a%20laptop%20screen%2C%20clean%20minimal%20web%20interface%20with%20warm%20color%20palette%2C%20creative%20web%20development%20workspace%20with%20desk%20plant%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-web-01&orientation=landscape',
    postedAt: '2026-08-19',
  },
  {
    id: 'gig-2',
    title: 'Logo professionnel et identité visuelle complète',
    freelancer: 'CreativeLab Studio',
    ownerId: 'freelancer-creativelab',
    category: 'Design',
    price: 45000,
    deliveryDays: 4,
    rating: 4.8,
    reviewsCount: 210,
    location: 'À distance',
    description:
      "Je crée un logo unique et mémorable pour votre marque, accompagné d'une palette de couleurs, de typographies et d'une charte graphique complète. Plusieurs propositions pour que vous choisissiez la bonne direction.",
    deliverables:
      "3 concepts de logo originaux\nFichiers sources (AI, SVG, PNG)\nPalette de couleurs\nChoix des typographies\nGuide d'utilisation de la marque",
    cover:
      'https://readdy.ai/api/search-image?query=Graphic%20designer%20sketching%20logo%20concepts%20on%20paper%20with%20color%20swatches%20and%20a%20tablet%20showing%20vector%20designs%2C%20modern%20creative%20studio%20with%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail&width=800&height=500&seq=gig-logo-02&orientation=landscape',
    postedAt: '2026-08-18',
  },
  {
    id: 'gig-3',
    title: 'Stratégie de contenu et gestion de vos réseaux sociaux',
    freelancer: 'Wax Digital',
    ownerId: 'freelancer-wax-digital',
    category: 'Marketing',
    price: 90000,
    deliveryDays: 14,
    rating: 4.7,
    reviewsCount: 87,
    location: 'Lomé',
    description:
      "Je définis votre stratégie de contenu et je gère vos réseaux sociaux pendant un mois : création de visuels, rédaction de légendes, planification et suivi des performances pour faire grandir votre communauté.",
    deliverables:
      "Stratégie de contenu sur mesure\n15 publications créées et planifiées\nVisuels adaptés à chaque réseau\nRapport mensuel de performance\nRéponses aux commentaires",
    cover:
      'https://readdy.ai/api/search-image?query=Social%20media%20manager%20planning%20content%20calendar%20on%20a%20laptop%20with%20smartphone%20showing%20analytics%2C%20modern%20marketing%20workspace%20with%20sticky%20notes%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-social-03&orientation=landscape',
    postedAt: '2026-08-17',
  },
  {
    id: 'gig-4',
    title: 'Rédaction d\'articles de blog optimisés SEO',
    freelancer: 'Plume Africaine',
    ownerId: 'freelancer-plume-africaine',
    category: 'Rédaction',
    price: 25000,
    deliveryDays: 3,
    rating: 4.9,
    reviewsCount: 156,
    location: 'À distance',
    description:
      "Je rédige des articles de blog engageants et optimisés pour le référencement. Contenu original, bien structuré et adapté à votre audience pour attirer du trafic et renforcer votre autorité en ligne.",
    deliverables:
      "Article de 1000 à 1500 mots\nRecherche de mots-clés\nStructure optimisée SEO\nRelecture et correction\n2 révisions incluses",
    cover:
      'https://readdy.ai/api/search-image?query=Writers%20hands%20typing%20on%20a%20laptop%20with%20a%20notebook%20and%20coffee%20cup%20beside%2C%20clean%20minimal%20writing%20workspace%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20high%20detail%2C%20calm%20and%20focused%20atmosphere&width=800&height=500&seq=gig-writing-04&orientation=landscape',
    postedAt: '2026-08-16',
  },
  {
    id: 'gig-5',
    title: 'Vidéo promotionnelle animée pour votre produit',
    freelancer: 'MotionCraft',
    ownerId: 'freelancer-motioncraft',
    category: 'Vidéo & Animation',
    price: 200000,
    deliveryDays: 10,
    rating: 4.6,
    reviewsCount: 54,
    location: 'À distance',
    description:
      "Je crée une vidéo promotionnelle animée de 60 secondes pour présenter votre produit ou service de façon impactante. Scénario, animation et habillage sonore inclus pour un rendu professionnel.",
    deliverables:
      "Vidéo animée de 60 secondes\nScénario et storyboard\nHabillage sonore et voix off\nExports en Full HD\n2 séries de modifications",
    cover:
      'https://readdy.ai/api/search-image?query=Video%20editor%20working%20on%20animation%20timeline%20in%20editing%20software%20on%20dual%20monitors%2C%20motion%20graphics%20workspace%20with%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20clean%20modern%20studio%2C%20high%20detail&width=800&height=500&seq=gig-video-05&orientation=landscape',
    postedAt: '2026-08-15',
  },
  {
    id: 'gig-6',
    title: 'Business plan et modèle financier pour lever des fonds',
    freelancer: 'Apeiron Consulting',
    ownerId: 'freelancer-apeiron',
    category: 'Business',
    price: 120000,
    deliveryDays: 9,
    rating: 4.8,
    reviewsCount: 68,
    location: 'Lomé',
    description:
      "J'accompagne les entrepreneurs dans la rédaction d'un business plan solide et la construction d'un modèle financier prévisionnel, prêts à être présentés à des investisseurs ou des banques.",
    deliverables:
      "Business plan complet (15-20 pages)\nModèle financier prévisionnel sur 3 ans\nÉtude de marché synthétique\nPitch deck de présentation\n1 session de conseil incluse",
    cover:
      'https://readdy.ai/api/search-image?query=Business%20consultant%20reviewing%20financial%20charts%20and%20a%20business%20plan%20document%20on%20a%20modern%20desk%2C%20professional%20office%20with%20warm%20lighting%2C%20growth%20strategy%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=800&height=500&seq=gig-business-06&orientation=landscape',
    postedAt: '2026-08-14',
  },
  {
    id: 'gig-7',
    title: 'Analyse de données et tableau de bord sur mesure',
    freelancer: 'Insight Analytics',
    ownerId: 'freelancer-insight',
    category: 'Data & IA',
    price: 180000,
    deliveryDays: 12,
    rating: 4.9,
    reviewsCount: 42,
    location: 'À distance',
    description:
      "Je transforme vos données brutes en insights actionnables. Nettoyage, analyse et création d'un tableau de bord interactif qui vous permet de suivre vos indicateurs clés en temps réel.",
    deliverables:
      "Nettoyage et préparation des données\nAnalyse statistique complète\nTableau de bord interactif\nRapport d'insights détaillé\nDocumentation d'utilisation",
    cover:
      'https://readdy.ai/api/search-image?query=Data%20analyst%20working%20with%20interactive%20charts%20and%20dashboards%20on%20a%20large%20monitor%2C%20data%20visualization%20workspace%2C%20modern%20office%20with%20warm%20lighting%2C%20professional%20editorial%20photography%2C%20high%20detail%2C%20clean%20composition&width=800&height=500&seq=gig-data-07&orientation=landscape',
    postedAt: '2026-08-13',
  },
  {
    id: 'gig-8',
    title: 'Production musicale et mixage de votre morceau',
    freelancer: 'BeatLab Studio',
    ownerId: 'freelancer-beatlab',
    category: 'Musique & Audio',
    price: 80000,
    deliveryDays: 6,
    rating: 4.7,
    reviewsCount: 39,
    location: 'Lomé',
    description:
      "Je produis et mixe votre morceau pour un rendu professionnel prêt à être diffusé. Composition, arrangement, mixage et mastering selon vos références artistiques.",
    deliverables:
      "Production musicale complète\nMixage et mastering\nFichiers en haute qualité\n2 révisions incluses\nVersion instrumentale",
    cover:
      'https://readdy.ai/api/search-image?query=Music%20producer%20working%20at%20a%20mixing%20console%20in%20a%20modern%20recording%20studio%2C%20warm%20ambient%20lighting%2C%20professional%20audio%20equipment%2C%20editorial%20photography%2C%20high%20detail%2C%20creative%20atmosphere&width=800&height=500&seq=gig-music-08&orientation=landscape',
    postedAt: '2026-08-12',
  },
];